import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

import { LoadingSpinnerBorderComponent } from "../shared/components/loading/loading-spinner-border/loading-spinner-border.component";
import { SessionStoreRepository } from '../shared/repositories/session.repository';
import { AccessLogService } from '../shared/services/accesslog.service';
import { AccessLog } from '../shared/models/access-log.model';
import { AccessLogsComponent } from "./access-logs/access-logs.component";
import { DeleteDataDialogComponent } from "./delete-data-dialog/delete-data-dialog.component";
import { ConsentService } from '../shared/services/consent.service';
import { BreadcrumbComponent } from "../shared/components/breadcrumb/breadcrumb.component";
import { ActivatedRoute } from '@angular/router';
import { ViewportScroller } from '@angular/common';

export interface PatientInfoData {
    ssn: string | null;
    firstName: string | null,
    lastName: string | null;
}

@Component({
    selector: 'web-patient-profile-page',
    imports: [AccessLogsComponent, CommonModule, LoadingSpinnerBorderComponent, TranslocoDirective, DeleteDataDialogComponent, BreadcrumbComponent],
    templateUrl: './patient-profile.component.html'
})

export class PatientProfilePageComponent implements OnInit {
    private readonly sessionService = inject(SessionStoreRepository);
    private readonly consentService = inject(ConsentService);
    private readonly accessLogService = inject(AccessLogService);
    private readonly route = inject(ActivatedRoute);
    private readonly viewportScroller = inject(ViewportScroller)

    private userInfo = this.sessionService.userInfo!;

    
    patientInfo: PatientInfoData | undefined;
    hasConsent: boolean | undefined;
    accessLogs: AccessLog[] = [];
    currentPage: number = 0;
    isLoading: boolean = false;
    cprVisible: boolean = false; 


    ngOnInit(): void {
        this.setPatientInfo();
        this.getDataProcessingAgreement();
        this.paginatePage(true);
    }

    private setPatientInfo() {
        this.patientInfo = {
            ssn: this.userInfo.cpr,
            firstName: this.userInfo.firstName,
            lastName: this.userInfo.lastName,
        };
    }
    
    private formatCpr(cpr: string): string {    
    if (cpr.length !== 10) {
        return cpr; 
    }
    return `${cpr.slice(0, 6)}-${cpr.slice(6)}`;
    }

    //Getter for ssn, calls formatCpr to insert dash (-). 
    //if cprVisible = true, returns unmasked value. 
    //if cprVisible = false, returns masked value with the last 4 digits replaced by X, 
    get maskedCpr(): string {
    const cpr = this.patientInfo?.ssn;
    if (!cpr) {
        return '';
    }
    const formatted = this.formatCpr(cpr);
    return this.cprVisible ? formatted : `${formatted.slice(0, -4)}XXXX`;
    }

    //Used to toggle cprVisible true/false
    toggleCprVisibility(): void{
        this.cprVisible = !this.cprVisible;
    }   
   

    private getDataProcessingAgreement() {
        this.consentService.postRetrievePatientConsent$().subscribe({
            next: (result: boolean) => {
                this.hasConsent = result;
            }
        });
    
    }
    private getAccesslogs() {
        this.route.fragment.subscribe(fragment => {
        this.accessLogService.getAccessLog$(this.currentPage).subscribe({
            next: data => {
                this.accessLogs = data;
                if(!fragment) return;

                setTimeout(() => {
                    this.viewportScroller.scrollToAnchor(fragment)
                }, 100);
            },
            error: () => {
                this.isLoading = false;
            },
            complete: () => {
                this.isLoading = false;
            }
        });
        });
    }

    paginatePage(nextPage: boolean): void {
        this.isLoading = true;

        if (nextPage) {
            this.currentPage++;
        } else if (this.currentPage > 1) {
            this.currentPage--;
        } else {
            this.isLoading = false;
            return;
        }

        this.getAccesslogs();
    }

}
